import QRCodeInstruction from './QRCodeInstruction';

export default QRCodeInstruction;
